module.exports = __webpack_public_path__ + "files/8d15b5cd52cd2b49ec0cb0adfc2833ca.png";